<template>
  <div>
    <b-card>
      <title-text />
      <summary-content />
      <content-text />
      <blog-category-active-card />
    </b-card>
    <seo-component data-store="blogCategories/dataItem" />
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Blog_categories/elements/TitleText.vue'
import SummaryContent from '@/views/Admin/Blog_categories/elements/SummaryContent.vue'
import ContentText from '@/views/Admin/Blog_categories/elements/ContentText.vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'
import BlogCategoryActiveCard from '@/views/Admin/Blog_categories/elements/ActiveCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BlogCategoryActiveCard,
    SeoComponent,
    BCard,
    TitleText,
    SummaryContent,
    ContentText,
  },
  computed: {
    itemData() {
      return this.$store.getters['blogCategories/dataItem']
    },
  },
}
</script>
